import React from "react"
import { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import QRCode from "../../assets/images/QRCode/QRCode.png"
import { MDBDataTable } from "mdbreact"
import PropTypes from "prop-types"
import classnames from "classnames"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Button,
  Modal,
  Label,
  Table,
} from "reactstrap"

export default function TotalOrders() {
  const [activeTab, setactiveTab] = useState(1)
  const [activeTabProgress, setactiveTabProgress] = useState(1)
  const [progressValue, setprogressValue] = useState(25)
  const [activeTabVartical, setoggleTabVertical] = useState(1)

  // -----------------View Order Popup----------------

  const [modal_center_1, setmodal_center_1] = useState(false)

  function view_ModelView() {
    setmodal_center_1(!modal_center_1)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  // -----------------End Order Popup----------------

  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab)
      }
    }
  }

  function toggleTabVertical(tab) {
    if (activeTabVartical !== tab) {
      if (tab >= 1 && tab <= 4) {
        setoggleTabVertical(tab)
      }
    }
  }

  // ------------------------------------------

  const ModelView = {
    columns: [
      {
        label: "Order No",
        field: "OrderNo",
        sort: "asc",
        attributes: { width: "14%" },
      },
      {
        label: "Customer Name",
        field: "CustomerName",
        sort: "asc",
        attributes: { width: "25%" },
      },
      {
        label: "Mobile Number",
        field: "MobileNumber",
        sort: "asc",
        attributes: { width: "16%" },
      },
      {
        label: "Time",
        field: "Time",
        sort: "asc",
        attributes: { width: "14%" },
      },
      {
        label: "Price",
        field: "Price",
        sort: "asc",
        attributes: { width: "12%" },
      },
      {
        label: "Status",
        field: "Status",
        sort: "asc",
        attributes: { width: "14%" },
      },
      {
        label: "View",
        field: "Actions",
        sort: "asc",
        attributes: { width: "5%" },
      },
    ],
    rows: [
      {
        OrderNo: "#6786788761",
        CustomerName: "Nishit Kachiya",
        MobileNumber: "+91 9638869115",
        Time: "02:55 PM",
        Price: "€3.49",
        Status: "Shipped",
        Actions: (
          <>
            <Button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="View"
              onClick={() => {
                setmodal_center_1(true)
              }}
            >
              <i className="fas fa-eye"></i>
            </Button>
          </>
        ),
      },
      {
        CustomerName: "Chirag Suthar",
        MobileNumber: "+91 9638869115",
        OrderNo: "#6786786458",
        OrderReceived: "01:49 PM",
        Time: "02:55 PM",
        Price: "€3.49",
        Status: "Out For Delivery",
        Actions: (
          <>
            <Button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="View"
              onClick={() => {
                setmodal_center_1(true)
              }}
            >
              <i className="fas fa-eye"></i>
            </Button>
          </>
        ),
      },
    ],
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Today's Orders | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs
            maintitle="Dashboard"
            title="Orders"
            breadcrumbItem="Today's Orders"
          />

          <Row>
            <Col sm="12">
              <Card>
                <CardBody>
                  <div
                    className="content clearfix"
                    style={{ marginTop: "30px" }}
                  >
                    <TabContent activeTab={activeTab} className="body">
                      <TabPane tabId={1}>
                        <Col className="col-12">
                          <MDBDataTable
                            responsive
                            bordered
                            noBottomColumns
                            theadColor={"btn-primary"}
                            data={ModelView}
                          />
                        </Col>
                      </TabPane>
                    </TabContent>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* --------------------------------Model-------------------------------- */}

          <Modal
            size="lg"
            isOpen={modal_center_1}
            toggle={() => {
              view_ModelView()
            }}
            centered={true}
          >
            <Col md={12} className="mb-4">
              <Button
                type="button"
                onClick={() => {
                  setmodal_center_1(false)
                }}
                className="close    "
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </Button>
            </Col>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Accepted Order</h5>
              <h5 className="modal-title mt-0">Accepted | 01.49PM</h5>
            </div>
            <div className="modal-body">
              <Row>
                <Col md={3} lg={3} sm={12} className="mb-3">
                  <center>
                    <div>
                      <img className="avatar-lg" alt="veltrix" src={QRCode} />
                    </div>
                  </center>
                </Col>

                <Col md={9} lg={9} sm={12} className="mb-3 row">
                  <Col md={3} lg={3} sm={3}>
                    <Label>
                      <b style={{ fontWeight: 600 }}>Branch Name</b>
                    </Label>
                  </Col>
                  <Col md={1} lg={1} sm={1}>
                    <Label>:</Label>
                  </Col>
                  <Col md={8} lg={8} sm={8}>
                    <Label> Sankalp</Label>
                  </Col>

                  <Col md={3} lg={3} sm={3}>
                    <Label>
                      <b style={{ fontWeight: 600 }}>City Name </b>
                    </Label>
                  </Col>
                  <Col md={1} lg={1} sm={1}>
                    <Label>:</Label>
                  </Col>
                  <Col md={8} lg={8} sm={8}>
                    <Label> Ahmedabad, India</Label>
                  </Col>

                  <Col md={3} lg={3} sm={3}>
                    <Label>
                      <b style={{ fontWeight: 600 }}>Order Date</b>
                    </Label>
                  </Col>
                  <Col md={1} lg={1} sm={1}>
                    <Label>:</Label>
                  </Col>
                  <Col md={8} lg={8} sm={8}>
                    <Label> 16/Jun/2022</Label>
                  </Col>

                  <Col md={3} lg={3} sm={3}>
                    <Label>
                      <b style={{ fontWeight: 600 }}>Order No.</b>
                    </Label>
                  </Col>
                  <Col md={1} lg={1} sm={1}>
                    <Label>:</Label>
                  </Col>
                  <Col md={8} lg={8} sm={8}>
                    <Label>#0003698524</Label>
                  </Col>

                  <Col md={3} lg={3} sm={3}>
                    <Label>
                      <b style={{ fontWeight: 600 }}>Delivery Time</b>
                    </Label>
                  </Col>
                  <Col md={1} lg={1} sm={1}>
                    <Label>:</Label>
                  </Col>
                  <Col md={8} lg={8} sm={8}>
                    <Label>02:00 to 04:00PM</Label>
                  </Col>
                </Col>
              </Row>
              <Row>
                <div className="table-responsive">
                  <Table className="table mb-3">
                    <thead className="table-light" color="btn-primary">
                      <tr>
                        <th style={{ width: "50%" }}>Item Name</th>
                        <th style={{ width: "15%", textAlign: "right" }}>
                          Quantity
                        </th>
                        <th style={{ width: "15%", textAlign: "right" }}>
                          Rate
                        </th>
                        <th style={{ width: "20%", textAlign: "right" }}>
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>VadaPav</td>
                        <td style={{ textAlign: "right" }}>2</td>
                        <td style={{ textAlign: "right" }}>100.00</td>
                        <td style={{ textAlign: "right" }}>200.00</td>
                      </tr>
                      <tr>
                        <td>Samosa</td>
                        <td style={{ textAlign: "right" }}>1</td>
                        <td style={{ textAlign: "right" }}>50.00</td>
                        <td style={{ textAlign: "right" }}>50.00</td>
                      </tr>
                      <tr>
                        <td>Pizza</td>
                        <td style={{ textAlign: "right" }}>3</td>
                        <td style={{ textAlign: "right" }}>150.00</td>
                        <td style={{ textAlign: "right" }}>450.00</td>
                      </tr>
                      <tr>
                        <td>PavBhaji</td>
                        <td style={{ textAlign: "right" }}>1</td>
                        <td style={{ textAlign: "right" }}>120.00</td>
                        <td style={{ textAlign: "right" }}>120.00</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Row>
              <Row>
                <Col md={6} lg={6} sm={12} className="mb-0"></Col>
                <Col md={6} lg={6} sm={12} className="mb-0">
                  <Label
                    md={6}
                    style={{ textAlign: "left", paddingLeft: "15px" }}
                  >
                    <b style={{ fontWeight: 600 }}>Item Total :</b>
                  </Label>
                  <Label
                    md={6}
                    style={{ textAlign: "right", paddingRight: "15px" }}
                  >
                    820.00
                  </Label>
                </Col>
                <Col md={6} lg={6} sm={12} className="mb-0"></Col>
                <Col md={6} lg={6} sm={12} className="mb-0">
                  <Label
                    md={6}
                    style={{ textAlign: "left", paddingLeft: "15px" }}
                  >
                    <b style={{ fontWeight: 600 }}>Discount :</b>
                  </Label>
                  <Label
                    md={6}
                    style={{ textAlign: "right", paddingRight: "15px" }}
                  >
                    82.00
                  </Label>
                </Col>
                <Col md={6} lg={6} sm={12} className="mb-0"></Col>{" "}
                <Col md={6} lg={6} sm={12} className="mb-1">
                  <Label
                    md={6}
                    style={{ textAlign: "left", paddingLeft: "15px" }}
                  >
                    <b style={{ fontWeight: 600 }}>Tax :</b>
                  </Label>
                  <Label
                    md={6}
                    style={{ textAlign: "right", paddingRight: "15px" }}
                  >
                    82.00
                  </Label>
                </Col>
                <Col md={6} lg={6} sm={12} className="mb-0"></Col>
                <Col md={6} lg={6} sm={12} className="mb-0">
                  <hr className="mt-0 mb-0"></hr>
                  <Label
                    md={6}
                    style={{ textAlign: "left", paddingLeft: "15px" }}
                  >
                    <b style={{ fontWeight: 600 }}>Total :</b>
                  </Label>
                  <Label
                    md={6}
                    style={{ textAlign: "right", paddingRight: "15px" }}
                  >
                    820.00
                  </Label>
                  <hr className="mt-0 mb-0"></hr>
                </Col>
                <Col md={12} lg={12} sm={12} className="mt-4">
                  <center>
                    <Button
                      color="primary"
                      className="btn btn-primary waves-effect waves-light"
                    >
                      Ready for Delivery
                    </Button>{" "}
                  </center>
                </Col>
              </Row>
            </div>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}
